import React, { ReactElement } from "react";
import { Motivering } from "../../../../components/Motivering";
import { Chapter } from "../../../../components/Chapter";
import Heading from "../../../../components/Heading";
import { ToelichtingHypotheekGeldverstrekkerHoofdstuk } from "../../../../../../.generated/rapportage/rapportagetypes";

export const ToelichtingAdviesGeldverstrekkerChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingHypotheekGeldverstrekkerHoofdstuk;
}): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text={hoofdstuk.titel ?? "Geldverstrekker"} level={3} />
        <Motivering
          wens={hoofdstuk.wens}
          advies={hoofdstuk.advies}
          keuze={hoofdstuk.keuze}
        />
      </div>
    </Chapter>
  );
};
